<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>RSL-EV设备管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入SN码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cpuid" @keyup.enter.native="clicksearch" placeholder="请输入芯片ID" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Sn" label="SN码" min-width="20%"></el-table-column>
          <el-table-column prop="Cpuid" label="芯片ID" min-width="20%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="20%"></el-table-column>
          <el-table-column label="操作" min-width="40%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goSecond(scope.row)">时长记录</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goThree(scope.row)">屈光度设置记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="时长记录" name="second" disabled="disabled">
        <RslEvCpuidTime ref="SubVueSecond" v-on:triggerFunc="BackToFirst"></RslEvCpuidTime>
      </el-tab-pane>

      <el-tab-pane label="屈光度设置记录" name="three" disabled="disabled">
        <RslevCpuidSetdiopter ref="SubVueThree" v-on:triggerFunc="BackToFirst"></RslevCpuidSetdiopter>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import RslEvCpuidTime from '@/componentsSubVue/RslEvCpuidTime.vue'
import RslevCpuidSetdiopter from '@/componentsSubVue/RslevCpuidSetdiopter.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RslEvCpuidTime,
    RslevCpuidSetdiopter
  },
  name: 'MyRslEvDeviceManage',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        sn: '',
        cpuid: ''
      }
    }
  },
  mounted () {
    this.apiGetRslEvDeviceNum()
    this.apiGetRslEvDeviceList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetRslEvDeviceList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetRslEvDeviceNum()
      this.apiGetRslEvDeviceList()
    },
    // 时长记录
    goSecond(row){
      this.activeName = 'second'
      this.$refs.SubVueSecond.LoadData(row)
    },
    goThree(row){
      this.activeName = 'three'
      this.$refs.SubVueThree.LoadData(row)
    },
    // 修改
    goModifyDeviceInformation (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { glassid: row.Id, Jigouid: row.Jigouid, Jigouname: row.Jigouname, Batchno: row.Batchno, Mac: row.Mac,Cardnumber: row.Cardnumber, Bomsn: row.Bomsn, BomsnName: row.BomsnName, Saletype: row.Saletype, SaletypeName: row.SaletypeName, Producename: row.Producename, Producetime: row.Producetime } })
    },
    // 更改归属机构
    clickModifyJigou (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { glassid: row.Id, Jigouid: row.Jigouid, Jigouname: row.Jigouname, Mac: row.Mac, Cardnumber: row.Cardnumber, Bomsn: row.Bomsn, BomsnName: row.BomsnName, Saletype: row.Saletype, SaletypeName: row.SaletypeName, Producename: row.Producename, Producetime: row.Producetime } })
    },
    apiGetRslEvDeviceList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        sn: that.keywords.sn,
        cpuid: that.keywords.cpuid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRslEvDeviceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetRslEvDeviceNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        sn: that.keywords.sn,
        cpuid: that.keywords.cpuid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRslEvDeviceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
